module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/en_2-82157f48a16f531f42edd398b9dc3d32.jpg";